import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import ToolPrepDownloadOptionsModal from "./ToolPrepDownloadOptionsModal";
import ToolPrepDownloadThankYouModal from "./ToolPrepDownloadThankYouModal";
import ToolPrepShareFriendsModal from "./ToolPrepShareFriendsModal";
import { clearToolPrepSession } from "../../../../utils/editorEntrySession";

const DASHBOARD_PATH = "/dashboard";

/**
 * Renders Download Options + Thank You + Share-with-friends from useToolPrepDownloadFlow.
 */
const ToolPrepDownloadFlowModals = ({
  flow,
  toolKey = "",
  onPrimaryAction = null,
  onBackToDashboard = null,
  optionsTitle,
  previewKind = "image",
  defaultFormatId = "png",
}) => {
  const navigate = useNavigate();

  const {
    variant,
    sourceFileName,
    options,
    closeOptions,
    confirmDownloadOptions,
    downloadBusy,
    thankYou,
    thankYouCopy,
    handleThankYouDismiss,
    handleShare,
    shareFriendsOpen,
    closeShareFriends,
    toolKey: flowToolKey,
    shareTitle,
  } = flow || {};

  const handleBackToDashboard = useCallback(() => {
    handleThankYouDismiss?.();
    if (typeof onBackToDashboard === "function") {
      onBackToDashboard();
      return;
    }
    try {
      clearToolPrepSession();
    } catch {
      // ignore
    }
    navigate(DASHBOARD_PATH);
  }, [handleThankYouDismiss, navigate, onBackToDashboard]);

  if (!flow) return null;

  return (
    <>
      <ToolPrepDownloadOptionsModal
        open={options.open}
        variant={variant}
        previewUrl={options.previewUrl}
        previewKind={previewKind}
        sourceFileName={sourceFileName}
        qualityOptions={options.qualityOptions}
        hasTransparency={options.hasTransparency}
        highQualityAlert={options.highQualityAlert}
        busy={downloadBusy}
        onClose={closeOptions}
        onConfirm={confirmDownloadOptions}
        title={optionsTitle || "Download"}
        defaultFormatId={defaultFormatId}
      />
      <ToolPrepDownloadThankYouModal
        open={thankYou.open}
        progress={thankYou.progress}
        phase={thankYou.phase}
        errorMessage={thankYou.errorMessage}
        imageUrl={thankYou.imageUrl}
        onClose={handleThankYouDismiss}
        onFinish={handleThankYouDismiss}
        onPrimaryAction={
          typeof onPrimaryAction === "function"
            ? onPrimaryAction
            : handleThankYouDismiss
        }
        onShare={handleShare}
        shareCopied={thankYou.shareCopied}
        onBackToDashboard={handleBackToDashboard}
        copy={thankYouCopy}
      />
      <ToolPrepShareFriendsModal
        open={Boolean(shareFriendsOpen)}
        toolKey={toolKey || flowToolKey || ""}
        shareTitle={shareTitle || "LazyStudio"}
        onClose={closeShareFriends}
      />
    </>
  );
};

export default ToolPrepDownloadFlowModals;
